<template>
  <div class="ad-tile">
    <LazyClassicNtpCommonOutbrainAdsWidgetWithFixCss
      :grid-position="index"
      :widget-id="widgetId"
      :is-summary-page-ad="isSummaryPageAd"
    />
  </div>
</template>
<script setup>
  const props = defineProps({
    tileWidth: {
      type: Number,
      default: 300,
    },
    tileHeight: {
      type: Number,
      default: 250,
    },
    index: {
      type: Number,
      default: null,
    },
    widgetId: {
      type: String,
      default: 'AR_7',
    },
    isSummaryPageAd: {
      type: Boolean,
      default: false,
    },
    isBottomAd: {
      type: Boolean,
      default: false,
    },
  })
  const tileWidth = props.isBottomAd ? 'auto' : props.tileWidth + 'px'
  const tileHeight = props.isBottomAd ? 'auto' : props.tileHeight + 'px'
</script>
<style lang="scss" scoped>
  .ad-tile {
    width: v-bind(tileWidth);
    height: v-bind(tileHeight);
  }
</style>
